export { default } from './SliderControl';
